import React from 'react';
import { ReportInlineModuleError } from '@americanexpress/travel-error-base';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { PageLevelNotification } from '@americanexpress/dls-react';
import { isInDate, isInvalidDateTime } from '../../utils/isInDate';
import { useDataFromOneCMS } from '../../fetchye/advisoryOneCMSFetchye';
import { moduleName } from '../../constants/moduleName';

const AdvisoryBanner = () => {
  const advisoryData = useDataFromOneCMS('advisory');
  const {
    startDate, endDate, startTime, endTime, content,
  } = advisoryData;
  const hasOneCMSContentError = !startDate || !endDate;

  const startDateTime = `${startDate} ${startTime}`;
  const endDateTime = `${endDate} ${endTime}`;

  const isInvalidStartTime = isInvalidDateTime(startDateTime);
  const isInvalidEndTime = isInvalidDateTime(endDateTime);

  if (hasOneCMSContentError || isInvalidStartTime || isInvalidEndTime) {
    return (
      <ReportInlineModuleError
        moduleID={moduleName}
        otherData={{
          componentID: 'AdvisoryBanner',
          causes: {
            oneCmsContent: hasOneCMSContentError,
            invalidDateTime: isInvalidStartTime || isInvalidEndTime,
          },
        }}
      />
    );
  }

  if (!isInDate(startDateTime, endDateTime) || !content) return null;

  return (
    <PageLevelNotification
      id="advisoryBanner"
      className="container flex flex-align-center"
      type="critical"
      isIconFilled={true}
    >
      <p dangerouslySetInnerHTML={{ __html: sanitize(content) }} />
    </PageLevelNotification>
  );
};

export default AdvisoryBanner;
